import React, { useState, useEffect, useRef } from "react";
import { MagnifyingGlass, X } from "@phosphor-icons/react";
import api from "@/lib/api";

const TYPE_LABEL = {
  star: "Star", planet: "Planet", dwarf_planet: "Dwarf Planet", moon: "Moon", deep_space: "Deep Space",
};

export default function SearchCommand({ open, onClose, onSelect }) {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) setTimeout(() => inputRef.current?.focus(), 50);
    else { setQ(""); setResults([]); }
  }, [open]);

  useEffect(() => {
    if (!q.trim()) { setResults([]); return; }
    const t = setTimeout(() => {
      api.get(`/objects/search?q=${encodeURIComponent(q)}`).then((r) => setResults(r.data.results));
    }, 150);
    return () => clearTimeout(t);
  }, [q]);

  if (!open) return null;

  return (
    <div
      data-testid="search-overlay"
      className="fixed inset-0 z-50 flex items-start justify-center pt-[12vh] px-4"
      style={{ background: "rgba(3,3,5,0.7)", backdropFilter: "blur(8px)" }}
      onClick={onClose}
    >
      <div className="w-full max-w-xl glass rounded-2xl overflow-hidden fade-up" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-3 px-5 py-4 border-b border-white/10">
          <MagnifyingGlass size={20} weight="duotone" color="#00D8FF" />
          <input
            ref={inputRef}
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Search planets, moons, stars, galaxies…"
            className="flex-1 bg-transparent outline-none text-white text-base placeholder:text-white/30"
          />
          <button onClick={onClose} className="text-white/40 hover:text-white transition-colors"><X size={20} /></button>
        </div>
        <div className="max-h-[50vh] overflow-y-auto">
          {results.length === 0 && q.trim() && (
            <div className="px-5 py-8 text-center text-white/40 text-sm">No objects match "{q}"</div>
          )}
          {results.map((o) => (
            <button
              key={o.id}
              data-testid={`search-result-${o.id}`}
              onClick={() => { onSelect(o.id); onClose(); }}
              className="w-full flex items-center gap-4 px-5 py-3.5 hover:bg-white/5 transition-colors text-left"
            >
              <span className="w-4 h-4 rounded-full flex-shrink-0" style={{ background: o.color, boxShadow: `0 0 10px ${o.color}` }} />
              <div className="flex-1 min-w-0">
                <div className="text-white font-medium text-sm">{o.name}</div>
                <div className="text-white/45 text-xs truncate">{o.tagline}</div>
              </div>
              <span className="text-tel text-[8px] text-white/35">{TYPE_LABEL[o.type]}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
